var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.48438 0 0 4.48438 0 10C0 15.5156 4.48438 20 10 20C15.5156 20 20 15.5156 20 10C20 4.48438 15.5156 0 10 0ZM10.832 15C10.832 15.4609 10.457 15.832 10 15.832C9.54297 15.832 9.16797 15.457 9.16797 15C9.16797 14.543 9.54297 14.168 10 14.168C10.457 14.168 10.832 14.5391 10.832 15ZM10 12.5C10.457 12.5 10.832 12.1289 10.832 11.668V5C10.832 4.54297 10.457 4.16797 10 4.16797C9.54297 4.16797 9.16797 4.53906 9.16797 5V11.668C9.16797 12.125 9.54297 12.5 10 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfoIcon);
export default __webpack_public_path__ + "static/media/AlertInfoIcon.6551205c03ee23c8a9f5afe9fb703a81.svg";
export { ForwardRef as ReactComponent };